/* =============================================================================
 * Erros do app.
 *
 * A API Prisma responde HTTP 200 mesmo quando o negocio falhou - o erro vem em
 * `data.Exception`. Aqui isso vira um throw, para que a view trate erro de rede
 * e erro de negocio no MESMO try/catch e mostre o mesmo componente de erro
 * dentro do proprio container (em vez do modal global do app antigo).
 * ========================================================================== */

const MENSAGEM_PADRAO = 'Não foi possível concluir a operação.';

export class ErroApi extends Error {
    constructor(excecao, nomeFuncionalidade, solicitacao) {
        const mensagem = excecao?.MensagemUsuario || excecao?.Messagem || MENSAGEM_PADRAO;
        super(mensagem);
        this.name = 'ErroApi';
        this.mensagemUsuario = mensagem;
        this.detalhes = excecao?.Detalhes || excecao?.Messagem || '';
        this.nomeFuncionalidade = nomeFuncionalidade;
        //Guardado para a tela de diagnostico do master: tempo de execucao e SQLs.
        this.solicitacao = solicitacao ?? null;
    }
}

export class ErroRede extends Error {
    /**
     * `semResposta` separa duas falhas que o app trata de formas opostas: a
     * requisicao que NAO CHEGOU ao servidor (DNS, avião, Wi-Fi sem internet) e a
     * que chegou e voltou com HTTP feio (500). So' a primeira e' sinal de que o
     * aparelho esta' offline - a segunda e' problema do servidor, e marcar o app
     * como offline por causa dela desviaria tudo para o conteudo do aparelho sem
     * necessidade. Ver shared/offline/conexao.js.
     */
    constructor(nomeFuncionalidade, causa, { semResposta = false } = {}) {
        super('Sem conexão com o servidor.');
        this.name = 'ErroRede';
        this.mensagemUsuario = 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
        this.detalhes = String(causa?.message || causa || '');
        this.nomeFuncionalidade = nomeFuncionalidade;
        this.causa = causa;
        this.semResposta = semResposta;
    }
}

/**
 * A chamada nao aconteceu porque o app esta' agindo como offline e o aparelho
 * nao tem essa resposta.
 *
 * NAO E' ErroRede de proposito: aqui nem se tentou a rede, e a saida oferecida a'
 * pessoa e' outra - baixar o conteudo, ou sair do modo offline. Ver
 * shared/offline/offline.js#deveBloquearChamada.
 */
export class ErroOffline extends Error {
    constructor(nomeFuncionalidade, { gravacao = false } = {}) {
        const mensagem = gravacao ? 'Esta ação precisa de conexão com a internet.' : 'Sem conexão e este conteúdo não está disponível offline.';
        super(mensagem);
        this.name = 'ErroOffline';
        this.mensagemUsuario = mensagem;
        this.detalhes = '';
        this.nomeFuncionalidade = nomeFuncionalidade;
        this.gravacao = gravacao;
    }
}

export class ErroTokenExpirado extends Error {
    constructor(excecao) {
        super('Sessão expirada.');
        this.name = 'ErroTokenExpirado';
        this.mensagemUsuario = 'Sua sessão expirou. Entre novamente.';
        this.detalhes = excecao?.Detalhes || '';
    }
}

/** O backend sinaliza token expirado por texto, nao por HTTP 401. */
export function ehErroDeToken(excecao) {
    const msg = String(excecao?.MensagemUsuario || '').toLowerCase();
    return msg.includes('token de autenticação') || msg.includes('token de autenticacao');
}

export function mensagemAmigavel(erro) {
    return erro?.mensagemUsuario || erro?.message || MENSAGEM_PADRAO;
}

/** Cancelamento de requisicao nao e' erro - e' navegacao. */
export function ehCancelamento(erro) {
    return erro?.name === 'AbortError';
}
